import React, { useState, useEffect, forwardRef } from 'react';
import './SelectionList.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

const SelectionList = forwardRef(function SelectionList(props, ref) {
  const { initialSelection, items, itemComponent: ItemComponent, itemComponentPropName, itemComponentOtherProps, itemKeyField, onSelect } = props;
  const [selectedItem, setSelectedItem] = useState(true);

  if (logComponent('SelectionList')) { console.debug('SelectionList rendered'); }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('SelectionList')) { console.debug('SelectionList onMount'); }
    focusFirstListItem();
  }, [])


  const focusFirstListItem = () => {
    if (logComponent('SelectionList')) { console.debug('SelectionList focusFirstListItem'); }
    if (ref) ref.current.focus();
  }

  const selectItem = (e) => {
    if (logComponent('SelectionList')) { console.debug('SelectionList selectItem'); }
    const { itemKey } = e.currentTarget.dataset;

    const newSelectedItem = items.find(item => item[itemKeyField] === itemKey);

    if (!newSelectedItem || 
        newSelectedItem[itemKeyField] === selectedItem[itemKeyField]) return;

    setSelectedItem(newSelectedItem);

    if (onSelect) onSelect(newSelectedItem);
  }


  return (
    <ul className="Selection-List">
      {
        items.map((item, index) => {
          let itemComponentProps = {}
          itemComponentProps[itemComponentPropName] = item;

          return (
            <li
              className="Selection-List__item"
              key={item[itemKeyField]}>
              <button
                className="Selection-List__button"
                data-item-key={item[itemKeyField]}
                onClick={selectItem}
                ref={index === 0 ? ref : null}>
                <ItemComponent {...itemComponentProps} {...itemComponentOtherProps} />
                <div className={'Selection-List__selection-indicator' +
                  (selectedItem[itemKeyField] === item[itemKeyField] ?
                    ' Selection-List__selection-indicator--selected' :
                    ' Selection-List__selection-indicator--deselected')}>
                  {
                    selectedItem[itemKeyField] === item[itemKeyField] ?
                      <FontAwesomeIcon icon="check" /> :
                      <FontAwesomeIcon icon="minus" />
                  }
                </div>
              </button>
            </li>);
        })
      }

    </ul>
  );
});
export default SelectionList;